import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c64ce2ee&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c64ce2ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64ce2ee",
  null
  
)

export default component.exports